import { render, staticRenderFns } from "./MediacontactPartnerCategoryCreate.vue?vue&type=template&id=4138b4b2"
import script from "./MediacontactPartnerCategoryCreate.vue?vue&type=script&lang=js"
export * from "./MediacontactPartnerCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports